// helpers
import {flatten} from './flatten';

// styles
import {defaultTheme} from '../default';
import {TextColors} from '../../styles';

// types
import {PortalConfig} from '../../services/ApiService/types/endpoints';

/**
 * Generate custom emotion theme to be used in the app
 * @param primaryColor
 * @param secondaryColor
 */
export const generateCustomEmotionTheme = (
  portalConfig: PortalConfig | null,
) => {
  if (portalConfig === null) {
    return defaultTheme;
  }

  const {primaryColor, secondaryColor} = portalConfig;

  const basicTheme = {
    ...defaultTheme,
    color: {
      ...defaultTheme.color,
      primary: primaryColor,
      primary_10: flatten(primaryColor, 0.1),
      primary_70: flatten(primaryColor, 0.7),
      secondary: secondaryColor,
      secondary_10: flatten(secondaryColor, 0.1),
      secondary_70: flatten(secondaryColor, 0.7),
    },
  };

  TextColors.brand = basicTheme.color.primary;
  TextColors.brandHover = basicTheme.color.primary_70;

  return basicTheme;
};
